import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import { put, takeEvery, all, fork } from "redux-saga/effects";
import axios from 'axios';
import HomeService from '../../services/home.service'

function* getRestaurantCategoriesStart(action) {
  try {
    let branch_id = null;
    let language_id = null;
    if(action){
      branch_id = action.payload?.branch_id;
      language_id = action.payload?.language_id;
    }
    console.log("🔄 SAGA: Fetching categories with:", { branch_id, language_id });
    const response = yield HomeService.getCategories(branch_id, language_id);
    console.log("📥 SAGA: Categories API response:", response?.data);
    if (response?.data) {
      console.log("✅ SAGA: Categories success, data structure:", response.data.data);
      yield put(actions.getRestaurantCategoriesSuccess(response.data.data));
    } else {
      console.log("❌ SAGA: Categories failed - no response data");
      yield put(actions.getRestaurantCategoriesFailure("network error"));
    }

  } catch (err) {
    console.error("❌ SAGA: Categories error:", err);
    let error = err?.response?.data?.message
    if (!error) error = 'network error'

    yield put(actions.getBannersFailure(error));
  }
}
function* getRestaurantCategoriesSaga() {
  yield takeEvery(actionsTypes.GET_RESTAURANT_CATEGORIES_START, getRestaurantCategoriesStart);
}

function* getProductStart(action) {
  try {
    let category_id = null;
    let category_ids = [];
    if(action.payload?.selectedCategoryId)
      category_id = action.payload?.selectedCategoryId;
    else if(action.payload?.category_ids)
      category_ids = action.payload?.category_ids;
    const language_id = action.payload?.language_id;
    const status = 1;
    console.log("🔄 SAGA: Fetching products with:", { category_id, category_ids, language_id });
    let response = null;
    if(category_id)
      response = yield HomeService.getProducts(category_id, language_id, status);
    else if(category_ids){
      const data = {
        category_ids, language_id, status
      }
      console.log("🔄 SAGA: Calling getAllCategoriesProducts with:", data);
      response = yield HomeService.getAllCategoriesProducts(data);
    }
    console.log("📥 SAGA: Products API response:", response?.data);
    if (response?.data) {
      console.log("✅ SAGA: Products success");
      yield put(actions.getProductSuccess(response?.data));
    } else {
      console.log("❌ SAGA: Products failed - no response data");
      yield put(actions.getProductFailure("network error"));
    }

  } catch (err) {
    console.error("❌ SAGA: Products error:", err);
    let error = err?.response?.data?.message
    if (!error) error = 'network error'

    yield put(actions.getProductFailure(error));
  }
}
function* getProductsSaga() {
  yield takeEvery(actionsTypes.GET_PRODUCT_LIST_START, getProductStart);
}

function* getCartItemsStart(action) {
  try {
    const order_id = action.payload?.order_id;
    const language_id = action.payload?.language_id;
    const status = 1;
    const response = yield HomeService.getCartItems(order_id, language_id, status);
    if (response?.data) {
      yield put(actions.getCartItemsSuccess(response?.data));
    } else {
      yield put(actions.getCartItemsFailure("network error"));
    }

  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) error = 'network error'

    yield put(actions.getCartItemsFailure(error));
  }
}
function* getCartItemsSaga() {
  yield takeEvery(actionsTypes.GET_CART_ITEMS_LIST_START, getCartItemsStart);
}


export function* categorySaga() {
  yield all([fork(getRestaurantCategoriesSaga)]);
}
export function* productSaga() {
  yield all([fork(getProductsSaga),fork(getCartItemsSaga)]);
}
